import { apiRequest } from "../api.jsx";

export const applyCoupon = (code) =>
  apiRequest("/coupon/apply", "POST", { code });

export const createCodOrder = (payload) =>
  apiRequest("/order/new", "POST", payload);

export const createPaymentOrder = (couponCode) =>
  apiRequest("/payment/create-order", "POST", { couponCode, currency: "INR" });

export const verifyPayment = (paymentInfo) =>
  apiRequest("/payment/verify", "POST", paymentInfo);

export const createOrderAfterPayment = (payload) =>
  apiRequest("/payment/create-order-after", "POST", payload);
